import styled from 'styled-components/';

export const CFContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const CFHeaderWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    border-bottom: 4px solid #F5FBFF;
`;

export const CFHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom:7px;
`;

export const CFHeaderTitle = styled.h4`
    font-size: 1.3rem;
    font-weight: bold;
    color:${({ theme }) => theme.colors.secondary};
`

export const CFHeaderActions = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    flex: 1;
`

export const CFBody = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
`

export const CFSection = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    @media (max-width: ${({ theme }) => theme.size.tabletL}) {
       flex-direction: column;
      }

`

export const CFFormWrapper = styled.div`
    width: 48%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 0.9rem;
    /* align-items: space-between; */
           @media (max-width: ${({ theme }) => theme.size.tabletL}) {
    width: 100%;
  }
`

export const CFFormSection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 1.5rem 2rem;
    border: 1px solid #D9E1E7CC; 
    border-radius: 16px;

    &:not(:last-child) {
        margin-bottom: 1rem;
    }

`

export const CFHierarchieSection = styled.div`
display: flex; 
justify-content:space-between;
padding-right: 54px;
  @media (max-width: ${({ theme }) => theme.size.tabletL}) {
   flex-direction: column;
  }
`

export const DPContainer = styled.div`

    margin-bottom: 0.5rem;

    & input {
        padding: 0.5rem !important;
        color: ${({ theme }) => theme.colors.secondary};
    }

    & button {
        color: ${({ theme }) => theme.colors.secondary};
    }

    & fieldset {
        border-color: ${({ theme }) => theme.colors.secondary};
    }

    & label {
        color: ${({ theme }) => theme.colors.secondary};
    }

    &:focus-within {
        & input {
            color: ${({ theme }) => theme.colors.primary};
        }
        & button {
            color: ${({ theme }) => theme.colors.primary};
        }
    }
`

export const ToggleLabel = styled.label`
    margin: 0;
    padding: 0;
    color: ${({active, theme}) => active ? theme.colors.success : theme.colors.secondary};
`;

export const ToggleIcon = styled.div`
    cursor: pointer;
    color: ${({active, theme}) => active ? theme.colors.success : theme.colors.secondary};
`;


export const CFFormGroup = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 0.2rem;
    margin-bottom: 0.8rem;
    border-bottom: 1px solid ${props => props.theme.colors.borderGray};
`;